module.exports = __webpack_public_path__ + "static/media/ES.0dccefdb.png";